import React from 'react'
import { Carousel, CaseItem } from '.'
import { WemoloAccordion, Button as WemoloButton, WemoloCheckCircleIcon } from '../../../components/Wemolo'
import { MLPCase, MLPCategory } from '../MLPContext'
import { useMLPStore } from '../MLPStore'
import styles from './MlpCase.module.css'

const CASE_STATE_LABEL: Record<MLPCategory, string> = {
    [MLPCategory.MLP]: 'Tolerated',
    [MLPCategory.Violator]: 'Offender confirmed'
}

export const MlpCaseItem: React.FC<{
    mlpCase: MLPCase
    isDone: boolean
    indexInBatch: number
    caseState: false | MLPCategory.MLP | MLPCategory.Violator
}> = ({ mlpCase, isDone, indexInBatch, caseState }) => {
    const addResult = useMLPStore((state) => state.addResult)
    let isCaseOver24Hours = false
    if (mlpCase?.offender?.timestamp_out && mlpCase?.offender?.timestamp_in) {
        isCaseOver24Hours =
            new Date(mlpCase?.offender?.timestamp_out).getTime() - new Date(mlpCase?.offender?.timestamp_in).getTime() >
            24 * 60 * 60 * 1000
    }

    const isToleratedSelected = caseState === MLPCategory.MLP
    const isOffenderSelected = caseState === MLPCategory.Violator

    const title = `Case ${indexInBatch + 1} (${mlpCase.offender.parking_lot})${
        caseState ? ` — ${CASE_STATE_LABEL[caseState]}` : ''
    }`

    const selectCategory = (category: MLPCategory) => {
        const added = addResult({ category, parking_results_uuid: mlpCase.offender.parking_results_uuid }, indexInBatch)
        if (added) {
            alert(added)
        }
    }

    return (
        <WemoloAccordion key={caseState || 'open'} title={title} defaultExpanded={!isDone}>
            <div className={styles.root}>
                <div className={styles.eventsRow}>
                    <div className={styles.eventCell}>
                        <CaseItem
                            title="IN EVENT"
                            isCaseOver24Hours={isCaseOver24Hours}
                            plate={mlpCase.offender.signed_url_in_lp}
                            timestamp={mlpCase.offender.timestamp_in}
                            deviceName={mlpCase.offender.device_id_in}
                            plateNumber={mlpCase.offender.plate}
                            imageSrc={mlpCase.offender.signed_url_in_render}
                            lpness={mlpCase.offender.lpness_in}
                            lpr={mlpCase.offender.lpr_in}
                        />
                    </div>

                    <div className={styles.eventCell}>
                        <CaseItem
                            title={'OUT EVENT'}
                            isCaseOver24Hours={isCaseOver24Hours}
                            plate={mlpCase.offender.signed_url_out_lp}
                            timestamp={mlpCase.offender.timestamp_out}
                            deviceName={mlpCase.offender.device_id_out}
                            plateNumber={mlpCase.offender.plate}
                            imageSrc={mlpCase.offender.signed_url_out_render}
                            lpness={mlpCase.offender.lpness_out}
                            lpr={mlpCase.offender.lpr_out}
                        />
                    </div>
                </div>
                <div className={styles.carouselRow}>
                    <div className={styles.carouselCell}>
                        <Carousel mlpCase={mlpCase} />
                    </div>
                </div>

                <div className={styles.actionsRow}>
                    <WemoloButton
                        size="medium"
                        view={isOffenderSelected ? 'ghost' : 'destructive'}
                        icon={isToleratedSelected ? <WemoloCheckCircleIcon /> : undefined}
                        onClick={() => selectCategory(MLPCategory.MLP)}
                        className={styles.actionButton}
                    >
                        Tolerate
                    </WemoloButton>
                    <WemoloButton
                        size="medium"
                        view={isToleratedSelected ? 'ghost' : 'primary'}
                        icon={isOffenderSelected ? <WemoloCheckCircleIcon /> : undefined}
                        onClick={() => selectCategory(MLPCategory.Violator)}
                        className={styles.actionButton}
                    >
                        Offender
                    </WemoloButton>
                </div>
            </div>
        </WemoloAccordion>
    )
}
